module.exports = "file1";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/extract-require/folder/file1.js
 ** module id = 2
 ** module chunks = 0
 **/